import isType from './is-type';

export default (str: any): str is string => {
  return isType(str, 'String');
}
